import axios from 'axios'
import { ihFaceDetectUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 上传数据生成特征码
export function faceCreate(params) {
  const url = ihFaceDetectUrl + '/faceDetect/create/feature'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '上传数据生成特征码', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除人脸数据
export function faceDelete(params) {
  const url = ihFaceDetectUrl + '/faceDetect/delete/feature/' + params.id
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '删除人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 编辑时根据id查询人脸数据
export function faceEditList(params) {
  const url = ihFaceDetectUrl + '/faceDetect/feature'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '编辑时根据id查询人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}
// 分页查询人脸数据
export function facePageList(params) {
  const url = ihFaceDetectUrl + '/faceDetect/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '分页查询人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}
// 修改人脸数据
export function faceUpdate(params) {
  const url = ihFaceDetectUrl + '/faceDetect/update/feature'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '修改人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}
// 修改人脸数据
export function batchImport(params, ouId, ouName) {
  const url = ihFaceDetectUrl + '/faceDetect/batch/feature?ouId=' + ouId + '&ouName=' + ouName
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(result => {
    if (result.status !== 200 || (!!result.data && result.data.state !== 0)) {
      errorCollection('人脸识别', '修改人脸数据', result)
    }
    return Promise.resolve(result.data)
  })
}
// 查询未绑定人脸数据的用户信息
export function faceDetectUserList(params) {
  const url = ihFaceDetectUrl + '/faceDetect/user/list'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '查询未绑定人脸数据的用户信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除用户同时删除绑定人脸数据
export function faceDeleteUser(params) {
  const url = ihFaceDetectUrl + '/faceDetect/delete/' + params.id
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人脸识别', '删除用户同时删除绑定人脸数据', res)
    }
    return Promise.resolve(res.data)
  })
}
